<footer class="bg-dark text-light py-5">
  <div class="container">
    <div class="row g-4">
      <!-- Logo and description -->
      <div class="col-12 col-md-4 mb-4" style="display: flex; justify-content: center; align-items: center;">
        <div class="footer-brand">
          <div class="logo-container">
            <img src="../../../assets/images/borde-footer.png" alt="Logo" class="footer-logo-img">
          </div>
          <!-- <p class="mt-4 description">Tu fuente confiable de noticias e información. Mantente informado con las últimas noticias y análisis en profundidad.</p> -->
        </div>
      </div>

      <!-- Quick links -->
      <div class="col-4 col-md-2">
        <h5 class="footer-heading mb-3">Secciones</h5>
        <ul class="list-unstyled footer-links">
          <li><a routerLink="/la-ciudad"><i class="bi bi-chevron-right"></i>La Ciudad</a></li>
          <li><a routerLink="/economia"><i class="bi bi-chevron-right"></i>Economía</a></li>
          <li><a routerLink="/deportes"><i class="bi bi-chevron-right"></i>Deportes</a></li>
          <li><a routerLink="/mundo"><i class="bi bi-chevron-right"></i>Mundo</a></li>
        </ul>
      </div>

      <!-- Contact information -->
      <div class="col-8 col-md-3">
        <h5 class="footer-heading mb-3">Contacto</h5>
        <ul class="list-unstyled footer-contact">
          <li>
            <div class="contact-item">
              <i class="bi bi-envelope-fill"></i>
              <span>contacto&#64;borde.com</span>
            </div>
          </li>
          <!-- <li>
            <div class="contact-item">
              <i class="bi bi-telephone-fill"></i>
              <span>(123) 456-7890</span>
            </div>
          </li> -->
          <!-- <li>
            <div class="contact-item">
              <i class="bi bi-geo-alt-fill"></i>
              <span>Calle Principal 123</span>
            </div>
          </li> -->
        </ul>
      </div>

      <!-- Social media -->
      <div class="col-12 col-md-3">
        <h5 class="footer-heading mb-3">Síguenos</h5>
        <div class="social-links" style="padding-top: 10px;">
          <a href="#" class="social-link facebook">
            <i class="bi bi-facebook"></i>
          </a>
          <a href="#" class="social-link twitter">
            <i class="bi bi-twitter-x"></i>
          </a>
          <a href="#" class="social-link instagram">
            <i class="bi bi-instagram"></i>
          </a>
          <a href="#" class="social-link youtube">
            <i class="bi bi-youtube"></i>
          </a>
        </div>
        <!-- <p class="social-text mt-3">Mantente conectado con nosotros en redes sociales para más noticias y actualizaciones.</p> -->
      </div>
    </div>

    <!-- Copyright -->
    <div class="footer-bottom mt-5 pt-4">
      <div class="row">
        <div class="col-12">
          <div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
            <p class="copyright mb-2 mb-md-0"> 2024 Borde. Todos los derechos reservados.</p>
            <ul class="footer-bottom-links list-inline mb-0">
              <li class="list-inline-item"><a href="#">Términos y Condiciones</a></li>
              <li class="list-inline-item separator">•</li>
              <li class="list-inline-item"><a href="#">Política de Privacidad</a></li>
            </ul>
          </div>
          <!-- Additional footer information -->
          <div class="footer-additional-info mt-3 text-center">
            <div class="small text-muted">
              <span>Director: Eric Reinoso</span>
              <span class="mx-2">•</span>
              <span>DNDA: En trámite</span>
              <span class="mx-2">•</span>
              <span>Edición n°: {{ editionNumber$ | async }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>